module.exports = __webpack_public_path__ + "img/turismo_portugal.4f10fe89.jpeg";